import { createClient, Client, ClientOptions } from 'graphql-ws';

interface RestartableClient extends Client {
	restart(): void;
}

function createRestartableWebsocketClient(options: ClientOptions): RestartableClient {
	let restartRequested = false;
	let restart = () => {
		restartRequested = true;
	};

	const client = createClient({
		...options,
		on: {
			...options.on,
			opened: (socket) => {
				options.on?.opened?.(socket);

				restart = () => {
					if (!(socket instanceof WebSocket)) {
						return;
					}

					if (socket.readyState === WebSocket.OPEN) {
						return socket.close(4205, 'Client Restart');
					}
					// otherwise the socket might've closed, indicate that you want
					// a restart on the next opened event
					restartRequested = true;
				};

				if (restartRequested) {
					restartRequested = false;
					restart();
				}
			},
		},
	});

	return {
		...client,
		restart: () => restart(),
	};
}

export { createRestartableWebsocketClient };
